<template v-slot:slides>
    <div class="swiper-container">
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
        <div class="swiper-wrapper"><slot></slot></div>
    </div>
</template>
<script>
import Swiper from "swiper";
export default {
    props: ["gallery"],
    methods: {},
    computed: {},
    mounted() {
        var clickedImage = this;
        var mySwiper = new Swiper(".swiper-container", {
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            noSwiping: false,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 0
                },
                1024: {
                    slidesPerView: 3,
                    slidesPerColumn: 2,
                    spaceBetween: 10
                }
            }
        });
    }
};
</script>
